import housingLowTilePath from '@/assets/tiles/housing_low.svg'
import meadowTilePath from '@/assets/tiles/meadow.svg'
import roadIntersectionTilePath from '@/assets/tiles/road_intersection.svg'
import roadNorthEastTilePath from '@/assets/tiles/road_north_east.svg'
import roadNorthEastSouthTilePath from '@/assets/tiles/road_north_east_south.svg'
import roadNorthSouthTilePath from '@/assets/tiles/road_north_south.svg'
import { assert } from '@/utils/assert'

import { TileKey } from '../constants'

const STORE: Record<TileKey, HTMLImageElement | undefined> = {
  [TileKey.HousingLow]: undefined,
  [TileKey.Meadow]: undefined,
  [TileKey.RoadIntersection]: undefined,
  [TileKey.RoadNorthEast]: undefined,
  [TileKey.RoadNorthEastSouth]: undefined,
  [TileKey.RoadNorthSouth]: undefined,
}

class TileStore {
  get(tileKey: TileKey): HTMLImageElement {
    assert(STORE[tileKey], `Tile "${tileKey}" not loaded.`)

    return STORE[tileKey]
  }

  async load() {
    STORE[TileKey.HousingLow] = await this.#getImageBitmapFromPath(housingLowTilePath)
    STORE[TileKey.Meadow] = await this.#getImageBitmapFromPath(meadowTilePath)
    STORE[TileKey.RoadIntersection] = await this.#getImageBitmapFromPath(roadIntersectionTilePath)
    STORE[TileKey.RoadNorthEast] = await this.#getImageBitmapFromPath(roadNorthEastTilePath)
    STORE[TileKey.RoadNorthEastSouth] = await this.#getImageBitmapFromPath(roadNorthEastSouthTilePath)
    STORE[TileKey.RoadNorthSouth] = await this.#getImageBitmapFromPath(roadNorthSouthTilePath)
  }

  async #getImageBitmapFromPath(path: string): Promise<HTMLImageElement> {
    return new Promise(resolve => {
      const image = new Image()
      image.onload = async () => {
        resolve(image)
      }
      image.onerror = error => {
        console.warn('[TileStore]', 'Error:', error)
      }
      image.src = path
    })
  }
}

export const tileStore = new TileStore()
